<template>
  <div class="wrap">
    <p v-if="customizationList.length" style="padding: 10px 0;color: red">
      此单涉及定制化产品，具体型号为：
      <el-tag v-for="(item,index) in customizationList" :key="index">
        {{ item.productName }}
      </el-tag>
      下单时请代理商支付此合同全部货款的30%进行下单，有疑问，请联系对应销售。
    </p>

    <el-form :inline="true">
      <el-form-item>
        <el-date-picker
          v-model="allAttribute.time"
          :picker-options="setBatchPickerOptions()"
          :default-value="batchPickerDefaultValue"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择期望发货日期"
          class="form-item-cell"
          :disabled="contractType==='SMB分销下单' && !hasEbgDeliveryRange"
        />
      </el-form-item>

      <el-form-item>
        <el-select
          v-model="allAttribute.freight"
          placeholder="请选择货运属性"
          class="form-item-cell"
        >
          <el-option
            v-for="(value, key) in freightProperty"
            :key="key"
            :label="value"
            :value="key"
          />
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-select
          v-model="taxRate"
          placeholder="请选择税率"
          class="form-item-cell"
        >
          <el-option
            v-for="item in taxRateList"
            :key="item.dictLabel"
            :label="item.dictValue"
            :value="item.dictLabel"
          />
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="batchSettings">
          批量设置
        </el-button>
        <el-button type="default" @click="setMaterialNum()">
          设置料号
        </el-button>
        <el-button type="default" @click="addNewRow">
          添加产品行
        </el-button>
        <el-button type="default" @click="setSerialNum">
          批量设置冲销序列号
        </el-button>
        <el-button type="default" @click="batchDeatail">
          删除勾选产品行
        </el-button>
        <el-button type="default" @click="taxRateSettings">
          批量设置税率
        </el-button>
        <el-button type="primary" @click="batchSetAddress">
          批量设置勾选产品收货地址(用于多地址发货)
        </el-button>
      </el-form-item>
      <br>
      <el-form-item>
        <el-select
          v-model="borrowBatchValue"
          clearable
          placeholder="是否冲销"
          class="form-item-cell-new"
        >
          <el-option
            v-for="item in borrowBatchOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-button type="primary" @click="batchSetBorrow">
          批量设置勾选产品测试借条转订单
        </el-button>
      </el-form-item>
    </el-form>

    <div style="color:red">
      注:1.若批量设置的日期不在客期可选范围,则需要重新设置或在产品行上单独设置
      2.若代理商发布合同时间和订单员发布合同时间间隔大于2天,则期望发货日期会在选择的日期上顺延相应间隔天数
      3.10月21日-12月15日之间的订单客期不能超过12月15日，12月16日-12月20日的订单客期不能超过12月20日（定制产品按供应SLA约束的除外，客期不能选节假日）
    </div>

    <!-- 表格 -->
    <el-table
      v-loading="isLoading"
      :data="productList"
      border
      show-summary
      :summary-method="getSummaries"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" align="left" />

      <el-table-column
        fixed
        type="index"
        width="50"
        label="序号"
        align="left"
      >
        <template v-slot="{ row, $index }">
          {{ (row.itemIndex = $index + 1) }}
        </template>
      </el-table-column>

      <el-table-column
        fixed
        prop="productCode"
        label="销售代码"
        align="left"
        min-width="100"
      />

      <el-table-column
        fixed
        prop="productName"
        label="产品型号"
        align="left"
        min-width="200"
      >
        <template v-slot="{ row }">
          <choose-product :row="row" :form="form" @change="((data) => changeProduce(data,row))" />
        </template>
      </el-table-column>

      <el-table-column
        fixed
        prop="productCode"
        label="料号"
        align="left"
        min-width="130"
      >
        <template v-slot="{ row, $index }">
          <el-button
            type="text"
            :disabled="
              row.exclusiveMaterialNumber != '' &&
                row.exclusiveMaterialNumber != null
            "
            @click="setSingleMaterialNum(row, $index)"
          >
            {{ row.materialNumberId ? row.materialNumberId : "选择料号" }}
          </el-button>
        </template>
      </el-table-column>

      <el-table-column
        v-if="contractType === '服务订单'"
        fixed
        prop="productNum"
        label="数量"
        align="left"
        width="150"
      >
        <template v-slot="{ row }">
          <el-input-number
            v-model="row.productNum"
            :disabled="row.isBorrow"
            :controls="false"
            style="width: 100%"
            @blur="changeSetMoney(row)"
          />
        </template>
      </el-table-column>
      <el-table-column
        v-else
        fixed
        prop="productNum"
        label="数量"
        align="left"
        width="150"
      >
        <template v-slot="{ row }">
          <el-input-number
            v-model="row.productNum"
            :disabled="row.isBorrow"
            :min="1"
            :controls="false"
            style="width: 100%"
            @blur="changeSetMoney(row)"
          />
        </template>
      </el-table-column>

      <el-table-column
        prop="unit"
        label="单位"
        align="left"
        width="60"
      />

      <el-table-column
        prop="productPriceSigle"
        label="单价"
        align="left"
        min-width="130"
      >
        <template v-slot="{ row }">
          <el-input-number
            v-model="row.productPriceSigle"
            :min="0"
            :controls="false"
            style="width: 100%"
            @blur="changeSetMoney(row)"
          />
        </template>
      </el-table-column>

      <el-table-column
        prop="orderAmount"
        label="订单金额"
        align="right"
        min-width="120"
        header-align="left"
      >
        <template v-slot="{ row }">
          {{ row.orderAmount }}
        </template>
      </el-table-column>

      <el-table-column
        prop="settlementAmount"
        label="实际结算金额"
        align="left"
        min-width="130"
      >
        <template v-slot="{ row }">
          <el-input-number
            v-model="row.settlementAmount"
            :precision="2"
            :step="0.01"
            :min="0"
            :controls="false"
            style="width: 100%"
          />
        </template>
      </el-table-column>

      <el-table-column
        prop="isBorrow"
        label="测试借条转订单"
        align="left"
        width="120"
      >
        <template v-slot="{ row, $index }">
          <el-checkbox
            v-model="row.isBorrow"
            :disabled="!!row.debitNum"
            @change="clickBorrow(row, $index)"
          />
        </template>
      </el-table-column>

      <el-table-column
        prop="debitNum"
        label="冲借销借用单号"
        align="left"
        min-width="150"
      />
      <el-table-column
        prop="expectedDeliveryDate"
        label="期望发货日期"
        align="left"
        min-width="160"
      >
        <template v-slot="{ row }">
          <el-date-picker
            v-model="row.expectedDeliveryDate"
            type="date"
            style="width: 100%"
            value-format="yyyy-MM-dd"
            placeholder="期望发货日期"
            :clearable="false"
            :disabled="contractType==='SMB分销下单'"
            :picker-options="setSinglePickerOptions(row)"
          />
        </template>
      </el-table-column>

      <el-table-column v-if="!isUnDisabledConType" label="客期可选范围" align="left" min-width="180">
        <template v-slot="{row}">
          <div class="text-left">
            {{ setFormatRangDate(row) }}
          </div>
        </template>
      </el-table-column>

      <el-table-column v-if="isEbgDepartment" label="供应SLA" align="left" min-width="100">
        <template v-slot="{ row }">
          {{ row.supplySla == null ? '-' : `${row.supplySla}天` }}
        </template>
      </el-table-column>

      <el-table-column
        prop="beforeSplitProductPriceSigle"
        label="拆分前单价"
        align="right"
        width="120"
        header-align="left"
      >
        <template v-slot="{ row }">
          <el-input-number
            v-if="row.addNew || (form && form.isNewContract)"
            v-model="row.beforeSplitProductPriceSigle"
            :min="0"
            :controls="false"
            style="width: 100%"
          />
          <span v-else>{{ row.beforeSplitProductPriceSigle }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="pname"
        label="货运属性"
        align="left"
        width="140"
      >
        <template v-slot="{ row }">
          <el-select v-model="row.freightProperty" :disabled="row.freightPropertyDisabled" placeholder="货运属性">
            <el-option
              v-for="(value, key) in freightProperty"
              :key="key"
              :label="value"
              :value="key"
            />
          </el-select>
        </template>
      </el-table-column>

      <el-table-column
        prop="pname"
        label="是否购买PSC"
        align="left"
        width="100"
      >
        <template v-slot="{ row }">
          {{ row.isPsc ? "是" : "否" }}
        </template>
      </el-table-column>

      <el-table-column
        prop="productConfigInfo"
        label="产品配置描述"
        align="left"
        min-width="180"
      />

      <el-table-column
        v-if="form.manufactureRefurbished"
        prop="manufactureRefurbished"
        label="是否官翻机产品"
        align="left"
        width="180"
      >
        <template v-slot="{ row }">
          {{ row.manufactureRefurbished ? "是" : "否" }}
        </template>
      </el-table-column>
      <el-table-column
        prop="detailedAddress"
        label="收货地址"
        align="left"
        width="200"
      >
        <template v-slot="{ row }">
          {{ row.contactName? (row.contactName + row.receiverProvince + row.receiverCity + row.receiverDistrict + row.detailedAddress + row.contactPhone) : '' }}
        </template>
      </el-table-column>

      <el-table-column
        prop="serviceDesc"
        label="服务备注"
        align="left"
        min-width="140"
      />

      <el-table-column
        label="库位"
        align="left"
        width="130"
      >
        <template v-slot="{ row }">
          <el-input
            v-model="row.location"
            :controls="false"
            style="width: 100%"
          />
        </template>
      </el-table-column>

      <el-table-column
        label="税率"
        align="left"
        width="130"
      >
        <template v-slot="{ row }">
          <el-select v-model="row.rate" placeholder="请选择税率">
            <el-option
              v-for="item in taxRateList"
              :key="item.dictLabel"
              :label="item.dictValue"
              :value="item.dictLabel"
            />
          </el-select>
        </template>
      </el-table-column>

      <el-table-column
        label="操作"
        align="left"
        width="130"
        fixed="right"
      >
        <template v-slot="{ row, $index }">
          <el-button type="text" @click="singleAddress(row, $index)">
            更改地址
          </el-button>
          <el-button
            v-if="row.productNum > 1"
            :disabled="row.isBorrow"
            type="text"
            style="padding: 0"
            @click="copyRow(row, $index)"
          >
            <i class="el-icon-circle-plus-outline" style="font-size: 16px" />
          </el-button>
          <el-button
            :disabled="row.isBorrow"
            type="text"
            style="padding: 0; color: #f56c6c"
            @click="removeProduct($index)"
          >
            <i class="el-icon-delete" style="font-size: 16px" />
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 批量设置冲销序列号 -->
    <set-serial
      :dialogvisible="dialogVisibleBool"
      :set-serial-data="setSerialData"
      @setSerialClose="setSerialClose"
      @getTableData="getTableData"
    />

    <!-- 料号 -->
    <material-num ref="MaterialNum" @chooseMateria="chooseMateria" @chooseMateriaNew="chooseMateriaNew" />

    <addressBox :prop-open.sync="isShow" @chooseAddress="changeAddress" @ChangeDatas="changeDatas" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import chooseProduct from '@/views/contractCommonInput/chooseProduct.vue';
import MaterialNum from '@/views/contractCommonInput/MaterialNum.vue';
import addressBox from '@/views/address/index.vue';
import setSerial from '@/views/contractCommonInput/setSerial.vue';
import { getReceiptAddressInfoModel, productOrdersPreparationTime } from '@/API';
import { getNum } from '@/libs/util';
import { getDictData } from '@/API/international';
import { calculateProductSettlementAmount } from '@/API/index.js';
import Big from 'big.js';
import dayjs from 'dayjs';

const EBG_DELIVERY_CONTRACT_TYPES = ['特价下单', '协议价下单', '非特价下单'];

// 产品行“测试借条转订单”变更存储数据，created 重置数据
let productOldData = {};

export default {
  components: {
    chooseProduct,
    MaterialNum,
    addressBox,
    setSerial
  },

  props: {
    communicationOrderDiscount: {
      type: [String, Number],
      default: 1
    },
    rebateAmount: {
      type: [String, Number],
      default: 0
    },
    rebate: {
      type: [Number],
      default: 1
    },
    salesType: {
      type: [String, Number],
      default: ''
    },
    isTestProject: {
      type: [Boolean, Number],
      default: false
    },
    contractId: {
      type: [String, Number],
      default: ''
    },
    contractType: {
      type: String,
      default: ''
    },
    form: {
      type: Object,
      default: () => {}
    },
    // table 列表数据
    list: {
      type: Array,
      default: () => []
    },
    isPilot: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      allAttribute: {
        time: '',
        freight: ''
      },

      // 税率
      taxRate: '',
      taxRateList: [],
      borrowBatchValue: '',
      borrowBatchOptions: [
        { label: '是', value: '1' },
        { label: '否', value: '0' }
      ],

      isLoading: false,

      productList: [],
      // 表格多选框选中数据
      multipleSelection: [],

      // 设置冲销序列号 弹框
      dialogVisibleBool: false,
      setSerialData: {},

      // 存放合计值
      summariesData: {},
      whereAddress: '', // 2批量设置地址 3单个数据地址
      singleIndex: null,
      isShow: false
    };
  },

  computed: {
    ...mapState({
      // 货运属性
      freightProperty: state => state.enumeration.freightProperty
    }),

    // 定制化产品
    customizationList () {
      return this.productList.filter((item) => item.customizationOrNot);
    },

    // 接口不处理禁用客期规则的合同类型
    isUnDisabledConType () {
      if (this.hasEbgDeliveryRange) {
        return false;
      }
      return ['SMB分销下单', '国际业务下单', '国际分销下单', '新建订单合同', '服务订单'].includes(this.contractType);
    },

    hasEbgDeliveryRange () {
      return this.isEbgDepartment &&
        this.productList.some(row => row.newDeliveryRule === true && row.minExpectedDate && row.maxExpectedDate && Array.isArray(row.holidayDates));
    },

    isEbgDepartment () {
      return (this.form.departmentCode || '').startsWith('000062');
    },

    // 订单员办理页面与渠道办理页面使用同一套 EBG 试点判断。
    isNewDeliveryRule () {
      return this.isPilot && EBG_DELIVERY_CONTRACT_TYPES.includes(this.contractType) &&
        this.form && typeof this.form.departmentCode === 'string' && this.form.departmentCode.startsWith('000062') &&
        !!this.form.createTime;
    },

    // 批量选择客期时，默认定位到第一个可选日期所在月份。
    batchPickerDefaultValue () {
      if (this.allAttribute.time) {
        return dayjs(this.allAttribute.time).toDate();
      }

      const pickerOptions = this.setBatchPickerOptions();
      let defaultDate = dayjs().startOf('day');
      if (this.isNewDeliveryRule || this.hasEbgDeliveryRange) {
        const minDate = this.productList
          .filter(row => row.minExpectedDate)
          .map(row => dayjs(row.minExpectedDate))
          .sort((a, b) => a.valueOf() - b.valueOf())[0];
        if (minDate && minDate.isAfter(defaultDate, 'day')) {
          defaultDate = minDate.startOf('day');
        }
      }

      for (let offset = 0; offset <= 3660; offset++) {
        const candidate = defaultDate.add(offset, 'day');
        if (!pickerOptions.disabledDate(candidate.toDate())) {
          return candidate.toDate();
        }
      }
      return defaultDate.toDate();
    }
  },

  watch: {
    list: {
      deep: true,
      handler (newVal) {
        this.productList = newVal.map((row, index) => ({ ...row, itemIndex: index }));
      }
    }
  },

  created () {
    productOldData = {};
    this.taxRateFn();
  },

  methods: {
    // 初始化料号组件
    initLiaohao () {
      if (!this.contractType) {
        return;
      }

      let productAndMaterialGroup = [];
      let MaterialNumValues = {};

      this.productList.forEach((item) => {
        if (item.productCode) {
          productAndMaterialGroup.push({
            productSalesCode: item.productCode,
            productName: item.productName,
            exclusiveMaterial: item.materialNumberId || '',
            productNum: item.productNum,
            isHavePowerCord: item.isHavePowerCord || false,
            isTestOrder: item.isBorrow || false
          });
          MaterialNumValues[item.productCode] = {
            materialNumberId: item.materialNumberId,
            materialUnit: item.materialUnit
          };
        }
      });

      let param = {
        contractType: this.form.saleTypeName || '',
        contractNumber: this.form.contractNum,
        contractName: this.form.projectName || '',
        materialReqProductVOS: productAndMaterialGroup
      };

      this.$refs.MaterialNum.initReturnLiaohao(param, MaterialNumValues);
    },
    batchSetAddress () {
      if (this.multipleSelection.length < 1) {
        this.$notify.error({
          title: '请选择需要设置地址的订单'
        });
        return;
      }
      this.whereAddress = '2';
      this.isShow = true;
    },
    singleAddress (row, index) {
      this.whereAddress = '3';
      this.singleIndex = index;
      this.isShow = true;
    },
    // 地址变更回到
    changeAddress (val) {
      // 选择其他地址
      if (this.whereAddress === '2') {
        this.multipleSelection.forEach((item) => {
          item.contactName = val.receiverName;
          item.receiverProvince = val.province;
          item.receiverCity = val.city;
          item.receiverDistrict = val.county;
          item.detailedAddress = val.receiptAddress;
          item.contactPhone = val.receiverPhone;
        });
      } else if (this.whereAddress === '3') {
        this.productList[this.singleIndex].contactName = val.receiverName;
        this.productList[this.singleIndex].receiverProvince = val.province;
        this.productList[this.singleIndex].receiverCity = val.city;
        this.productList[this.singleIndex].receiverDistrict = val.county;
        this.productList[this.singleIndex].detailedAddress = val.receiptAddress;
        this.productList[this.singleIndex].contactPhone = val.receiverPhone;
      }
      this.isShow = false;
      this.$emit('chooseAddress', val);
    },

    // 地址选择 地址源地址列表发生变化，需要用当前地址id 重新查询地址信息
    changeDatas () {
      if (this.address.id) {
        getReceiptAddressInfoModel(this.address.id).then((res) => {
          let { status, data } = res.data;
          if (status === '200') {
            if (!data.isDelete) {
              this.address = data;
            } else {
              this.address = {};
            }
          }
        });
      }
    },
    /**
     * 设置批量设置客期的禁用规则，规则：
     * 1. 接口处理的合同类型：满足条件的当天开始的90天可以选择
     * 2. 服务订单：不做限制，大于等于当天即可
     */
    setBatchPickerOptions () {
      let _this = this;
      return {
        disabledDate (time) {
          if ((_this.isNewDeliveryRule || _this.hasEbgDeliveryRange) &&
            ([0, 6].includes(dayjs(time).day()) || _this.productList.some(row => Array.isArray(row.holidayDates) && row.holidayDates.includes(dayjs(time).format('YYYY-MM-DD HH:mm:ss'))))) {
            return true;
          }
          if (_this.isNewDeliveryRule || _this.hasEbgDeliveryRange) {
            const minDate = _this.productList
              .filter(row => row.minExpectedDate)
              .map(row => dayjs(row.minExpectedDate))
              .sort((a, b) => a.valueOf() - b.valueOf())[0];
            const maxDate = _this.productList
              .filter(row => row.maxExpectedDate)
              .map(row => dayjs(row.maxExpectedDate))
              .sort((a, b) => b.valueOf() - a.valueOf())[0];
            return (minDate && dayjs(time).isBefore(minDate, 'day')) || (maxDate && dayjs(time).isAfter(maxDate, 'day'));
          } else if (!_this.isUnDisabledConType) {
            // 规则：直签项目 365 天可选择，其他当天开始的90天可以选择
            if (_this.form.asInterDirect) {
              return dayjs(time).isBefore(dayjs().subtract(1, 'day')) || dayjs(time).isAfter(dayjs().add(365, 'day'));
            } else {
              return dayjs(time).isBefore(dayjs().subtract(1, 'day')) || dayjs(time).isAfter(dayjs().add(89, 'day'));
            }
          } else if (_this.contractType === '服务订单') {
            return dayjs(time).isBefore(dayjs().subtract(1, 'day'));
          } else {
            return false;
          }
        }
      };
    },

    // 设置产品行客期的禁用规则
    setSinglePickerOptions (row) {
      let _this = this;

      return {
        disabledDate (time) {
          return row.productName ? _this.getRowDisabledRule(row, time) : false;
        }
      };
    },

    /**
     * 设置产品行客期的禁用规则，规则：
     * 1. 接口处理的合同类型：产品行规则 小于开始，大于结束，中间的法定节假日 禁用(接口字段盘判断)
     * 1.1 历史规则下冲销只有最小时间；新规则下冲销与普通产品使用同一范围
     * 2. 服务订单：不做限制，大于等于当天即可
     * 3. 其他不做验证
    */
    getRowDisabledRule (row, time) {
      if ((this.isNewDeliveryRule || this.hasEbgDeliveryRange) && row.minExpectedDate && row.maxExpectedDate) {
        return dayjs(time).isBefore(dayjs(row.minExpectedDate), 'day') || dayjs(time).isAfter(dayjs(row.maxExpectedDate), 'day') ||
          [0, 6].includes(dayjs(time).day()) ||
          (Array.isArray(row.holidayDates) && row.holidayDates.includes(dayjs(time).format('YYYY-MM-DD HH:mm:ss')));
      } else if (!this.isUnDisabledConType) {
        let { minExpectedDate, maxExpectedDate, holidayDates } = row;
        if (minExpectedDate && maxExpectedDate && holidayDates) {
          return dayjs(time).isBefore(dayjs(minExpectedDate)) || holidayDates.includes(dayjs(time).format('YYYY-MM-DD HH:mm:ss')) || dayjs(time).isAfter(dayjs(maxExpectedDate));
        } else if (minExpectedDate && !maxExpectedDate && !holidayDates) {
          // 冲销
          return dayjs(time).isBefore(dayjs(minExpectedDate));
        } else {
          return false;
        }
      } else if (this.contractType === '服务订单') {
        return dayjs(time).isBefore(dayjs().subtract(1, 'day'));
      } else {
        return false;
      }
    },

    // 获取税率
    taxRateFn () {
      let params = { dictType: 'tax_rate' };
      getDictData(params).then(res => {
        let { status, data } = res.data;
        if (status === '200') {
          this.taxRateList = data;
        }
      });
    },

    // 批量设置
    batchSettings () {
      const failedRows = [];
      this.productList.forEach((row, index) => {
        if (this.allAttribute.time && (this.contractType !== 'SMB分销下单' || this.hasEbgDeliveryRange)) {
          // 产品行符合禁用规则可以进行赋值
          if (!this.getRowDisabledRule(row, this.allAttribute.time)) {
            this.$set(row, 'expectedDeliveryDate', this.allAttribute.time);
          } else {
            failedRows.push(`第${index + 1}行 ${row.productName || row.productCode || '未选择产品'}`);
          }
        }

        if (this.allAttribute.freight) {
          this.$set(row, 'freightProperty', this.allAttribute.freight);
        }

        if (this.taxRate) {
          this.$set(row, 'rate', this.taxRate);
        }
      });

      if (failedRows.length) {
        const message = this.$createElement('div', failedRows.map(label => this.$createElement('div', label)));
        this.$alert(message, '批量设置失败', { type: 'error' }).catch(() => null);
      }
    },

    // 客期可选范围
    setFormatRangDate (row) {
      let { minExpectedDate, maxExpectedDate } = row;
      if (minExpectedDate && maxExpectedDate) {
        return `${minExpectedDate.slice(0, 10)} ~ ${maxExpectedDate.slice(0, 10)}`;
      } else if (minExpectedDate && !maxExpectedDate) {
        return `${minExpectedDate.slice(0, 10)} ~ `;
      }
    },

    // 更改产品型号获取禁用规则并清空期望发货日期
    changeProduce ({ data }, row) {
      let { minExpectedDate, maxExpectedDate, holidayDates } = data;
      row.expectedDeliveryDate = '';
      this.$set(row, 'predictionRequiredDeliveryDate', null);
      this.$set(row, 'supplySla', null);
      minExpectedDate && this.$set(row, 'minExpectedDate', minExpectedDate);
      maxExpectedDate && this.$set(row, 'maxExpectedDate', maxExpectedDate);
      holidayDates && this.$set(row, 'holidayDates', holidayDates);
      if (this.isEbgDepartment) {
        this.refreshExpectedDeliveryDateRange([row]);
      }
    },

    async refreshExpectedDeliveryDateRange (targetRows) {
      if (!targetRows || !targetRows.length) {
        return;
      }
      try {
        const response = await productOrdersPreparationTime({
          contractNum: this.form.contractNum,
          contractType: this.contractType,
          asInterDirect: this.form.asInterDirect,
          departmentCode: this.form.departmentCode,
          createTime: this.form.createTime,
          requiredDeliveryDate: this.form.requiredDeliveryDate,
          agreedShippingDate: this.form.agreedShippingDate,
          productCodeAndBorrowList: targetRows
            .filter(row => row.productCode && row.productName !== '价外费用-运费')
            .map(row => ({ productCode: row.productCode, isBorrow: row.isBorrow }))
        });
        const json = response.data || {};
        const ranges = Array.isArray(json.data) ? json.data : [];
        const rangeMap = ranges.reduce((map, item) => {
          map[item.productCode] = item;
          return map;
        }, {});
        targetRows.forEach(row => {
          if (!row.productCode || row.productName === '价外费用-运费') {
            return;
          }
          const range = rangeMap[row.productCode];
          if (range) {
            this.$set(row, 'predictionRequiredDeliveryDate', range.predictionRequiredDeliveryDate);
            this.$set(row, 'supplySla', range.supplySla);
            if (this.isEbgDepartment) {
              this.$set(row, 'minExpectedDate', range.minExpectedDate);
              this.$set(row, 'maxExpectedDate', range.maxExpectedDate);
              this.$set(row, 'holidayDates', range.holidayDates);
              this.$set(row, 'newDeliveryRule', range.newDeliveryRule);
              // 历史规则保持原有“更换型号后由用户选择”的行为；新规则默认为下限。
              if (range.newDeliveryRule && range.minExpectedDate) {
                this.$set(row, 'expectedDeliveryDate', range.minExpectedDate);
              }
            }
          }
        });
      } catch (e) {
        // 统一响应拦截器负责展示后端返回的错误，页面不覆盖原有客期数据。
      }
    },

    // 设置料号
    setMaterialNum (row, index) {
      if (!this.contractType) {
        this.$notify.error({ message: '请先选择订单分类' });
        return;
      }

      let productAndMaterialGroup = [];
      let MaterialNumValues = {};

      this.productList.forEach((item) => {
        if (item.productCode) {
          productAndMaterialGroup.push({
            productSalesCode: item.productCode,
            productName: item.productName,
            exclusiveMaterial: item.materialNumberId || '',
            productNum: item.productNum,
            isHavePowerCord: item.isHavePowerCord || false,
            isTestOrder: item.isBorrow || false
          });
          MaterialNumValues[item.productCode] = {
            materialNumberId: item.materialNumberId,
            materialUnit: item.materialUnit
          };
        }
      });

      let param = {
        contractType: this.form.saleTypeName || '',
        contractNumber: this.form.contractNum,
        contractName: this.form.projectName || '',
        materialReqProductVOS: productAndMaterialGroup
      };

      this.$refs.MaterialNum.showdialog(param, index, MaterialNumValues);
    },

    // 设置单个料号
    setSingleMaterialNum (row, index) {
      if (!this.contractType) {
        this.$notify.error({ message: '请先选择订单分类' });
        return;
      }

      let productAndMaterialGroup = [];
      let MaterialNumValues = {};

      if (row.productCode) {
        productAndMaterialGroup.push({
          productSalesCode: row.productCode,
          productName: row.productName,
          exclusiveMaterial: row.materialNumberId,
          productNum: row.productNum,
          isHavePowerCord: row.isHavePowerCord || false,
          isTestOrder: row.isBorrow || false
        });
        MaterialNumValues[row.productCode] = {
          materialNumberId: row.materialNumberId,
          materialUnit: row.materialUnit
        };
      }

      let param = {
        contractType: this.form.saleTypeName || '',
        contractNumber: this.form.contractNum,
        contractName: this.form.projectName || '',
        materialReqProductVOS: productAndMaterialGroup
      };

      this.$refs.MaterialNum.showdialog(param, index, MaterialNumValues);
    },
    chooseMateriaNew ({ list }) {
      list.forEach((mate) => {
        this.productList.forEach((pro) => {
          if (pro.productCode === mate.productSalesCode && !pro.isBorrow) {
            pro.materialNumberId = mate.selected;
            // 兼容字段materialUnit为空的时候
            pro.materialUnit = mate.materialUnit || '';
            pro.softFlag = mate.softFlag || '';
          }
        });
      });
    },
    // 选择料号回调
    chooseMateria ({ list, RowIndex }) {
      // 设置表单值
      let setTableProps = (RowIndex, data) => {
        this.productList[RowIndex].materialNumberId = data.selected;
        this.productList[RowIndex].materialUnit = data.materialUnit;
        this.productList[RowIndex].softFlag = data.softFlag;
      };

      // 判断是否是设置单个料号
      if (RowIndex === 'all') {
        list.forEach((data, index) => {
          let row = this.productList[index];
          if (row.productCode === data.productSalesCode) {
            setTableProps(index, data);
          }
        });
      } else {
        setTableProps(RowIndex, list[0]);
      }
    },

    // 添加行
    addNewRow () {
      this.productList.push({
        orderAmount: 0,
        settlementAmount: 0,
        materialNumberId: '',
        productNum: 0,
        productPriceSigle: 0,
        beforeSplitProductPriceSigle: 0,
        removeVisible: false,
        addNew: true,
        expectedDeliveryDate: ''
      });
    },

    // 设置序列号
    setSerialNum () {
      this.setSerialData = {
        'contractId': this.contractId,
        'getGoodsList': this.productList
      };
      this.dialogVisibleBool = true;
    },

    // 设置序列号弹框关闭
    setSerialClose (val) {
      this.dialogVisibleBool = val;
    },

    // 获取序列号列表数据
    getTableData (array) {
      array.forEach(row => {
        if (row.isBorrow && !row.minExpectedDate && !this.isNewDeliveryRule && !this.hasEbgDeliveryRange) {
          row.minExpectedDate = dayjs().format('YYYY-MM-DD HH:mm:ss');
        }
      });

      this.productList = array;
      let choose = this.productList.filter(item => item.splitSoftwareName && item.isBorrow);
      choose.forEach((item) => {
        this.productList.forEach((ite) => {
          ite.isBorrow = ite.productCode === item.splitSoftwareName;
        });
      });
    },

    // table 多选框 获取选中数据
    handleSelectionChange (val) {
      this.multipleSelection = val;
    },

    // 删除勾选产品行
    batchDeatail () {
      if (this.multipleSelection.length === 0) {
        this.$message.error('请勾选需要删除产品行');
        return;
      }
      this.$confirm('是否删除勾选产品行?', '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let list = this.multipleSelection.map(row => row.itemIndex);
          this.productList = this.productList.filter(row => !list.includes(row.itemIndex));
          this.multipleSelection = [];
        }).catch(() => {});
    },

    // 批量设置税率
    taxRateSettings () {
      if (this.taxRate) {
        this.productList.forEach((item) => {
          this.$set(item, 'rate', this.taxRate);
        });
      }
    },

    // 复制行
    copyRow (row, index) {
      this.productList.splice(index + 1, 0, { ...this.$cloneDeep(row), copy: true, idBak: row.id, id: null });
      // this.productList.splice(index + 1, 0, { ...this.$cloneDeep(row), id: null });
    },

    // 删除行
    removeProduct (index) {
      this.$confirm('是否删除该产品?', '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.productList.splice(index, 1);
        })
        .catch(() => { });
    },

    cacheBorrowRule (row, index) {
      if (productOldData[index]) {
        return;
      }

      productOldData[index] = {
        minExpectedDate: row.minExpectedDate,
        maxExpectedDate: row.maxExpectedDate,
        holidayDates: row.holidayDates
      };
    },

    updateBorrowState (row, index, isBorrow) {
      row.isBorrow = isBorrow;
      row.freightProperty = isBorrow ? '20' : '';

      this.productList.forEach((item) => {
        if (row.splitSoftwareName && row.splitSoftwareName === item.productCode) {
          item.isBorrow = isBorrow;
        }
      });

      if (isBorrow) {
        this.cacheBorrowRule(row, index);
        if (this.isNewDeliveryRule || this.hasEbgDeliveryRange) {
          return;
        } else {
          row.minExpectedDate = dayjs().format('YYYY-MM-DD 00:00:00');
          row.maxExpectedDate = null;
          row.holidayDates = null;
        }
        return;
      }

      if (!productOldData[index]) {
        return;
      }

      row.minExpectedDate = productOldData[index].minExpectedDate;
      row.maxExpectedDate = productOldData[index].maxExpectedDate;
      row.holidayDates = productOldData[index].holidayDates;
      productOldData[index] = null;
    },

    isSelectedRow (row) {
      return this.multipleSelection.some((item) => item === row || item.itemIndex === row.itemIndex);
    },

    batchSetBorrow () {
      if (!this.borrowBatchValue || !this.multipleSelection.length) {
        return;
      }

      let isBorrow = this.borrowBatchValue === '1';
      let availableIndexes = this.multipleSelection
        .map((selectedRow) => this.productList.findIndex((item) => item.itemIndex === selectedRow.itemIndex))
        .filter((index) => index !== -1 && !this.productList[index].debitNum);

      availableIndexes.forEach((index) => {
        this.updateBorrowState(this.productList[index], index, isBorrow);
      });
    },

    // 测试借条转订单
    clickBorrow (row, index) {
      this.updateBorrowState(row, index, row.isBorrow);
    },

    // 数量、单价，变更调用接口计算获取：订单金额和实际结算金额
    changeSetMoney (row) {
      let params = {
        // 合同返点
        rebate: this.rebate,
        // 返利金额
        rebateAmount: this.rebateAmount,
        // 通讯折扣
        communicationOrderDiscount: this.communicationOrderDiscount,
        // 1 现销 2 赊销
        salesType: this.salesType,
        productList: this.productList.map((item) => ({
          id: item.id,
          productCode: item.productCode,
          productCategoryName: item.productCategoryName,
          productPriceSingle: item.productPriceSigle,
          productNum: item.productNum
        }))
      };
      this.isLoading = true;

      calculateProductSettlementAmount(params)
        .then(res => {
          let { status, data } = res.data;
          this.isLoading = false;
          if (status === '200') {
            this.productList.forEach((item, index) => {
              let result = data[index];
              item.orderAmount = result.orderAmount;
              item.settlementAmount = result.settlementAmount;
            });
          }
        })
        .catch(() => {
          row.productNum = 0;
          row.productPriceSigle = 0;
          row.orderAmount = 0;
          row.settlementAmount = 0;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    // 计算合计
    getSummaries ({ columns, data }) {
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }

        if (column.label === '数量') {
          sums[index] = data.reduce((pre, cur) => getNum(Big(getNum(cur.productNum)).plus(pre).toString()), 0);
          this.summariesData.productNum = sums[index];
          return;
        }
        if (column.label === '订单金额') {
          sums[index] = data.reduce((pre, cur) => getNum(Big(getNum(cur.orderAmount)).plus(pre).toString()), 0);
          this.summariesData.orderAmount = sums[index];
          return;
        }

        if (column.label === '产品型号') {
          let count = data.reduce((pre, cur) => {
            if (cur.isBorrow) {
              return getNum(Big(getNum(cur.productNum)).times(getNum(cur.beforeSplitProductPriceSigle)).plus(pre).toString());
            } else {
              return pre;
            }
          }, 0);

          sums[index] = '冲销合计:' + count + '元';
          return;
        }

        if (column.label === '实际结算金额') {
          sums[index] = data.reduce((pre, cur) => getNum(Big(getNum(cur.settlementAmount)).plus(pre).toString()), 0);
          this.summariesData.settlementAmount = sums[index];
          return;
        }

        if (column.label === '拆分前单价') {
          sums[index] = data.reduce((pre, cur) => {
            return getNum(Big(getNum(cur.productNum)).times(getNum(cur.beforeSplitProductPriceSigle)).plus(pre).toString());
          }, 0);
          this.summariesData.beforeSplitProductPriceSigle = sums[index];
        }
      });

      return sums;
    },

    // 暴露出去的数据
    getSubmitData () {
      return {
        productList: this.productList,
        summariesData: this.summariesData
      };
    }

  },
  async mounted () {
    await this.$nextTick();
    setTimeout(() => {
      this.initLiaohao();
    }, 2000);
  }
};
</script>

<style lang="scss" scoped>
.wrap {
  padding: 20px;
}

.form-item-cell{
  width: 170px;
}

.form-item-cell-new{
  width: 120px;
  margin-right: 12px;
}

.text-left{
  text-align: left;
}
</style>
